import mecoLogo from "./meco-logo.svg";
import { Box } from "@mui/material";
import { BoxProps } from "@mui/material/Box/Box";

export function MecoLogo(props: BoxProps) {
  return <Box component="img" src={mecoLogo} alt="Meco Logo" {...props} />;
}
